export const apiConstants = {
  clients: '/clients',
  orders: '/orders',
  order: '/order',
};
